import { connect } from 'react-redux'
import {
  createMspProject, loadStepsForMspProject, assignStep
} from 'actions/projects/msp_step_button_actions'

export default connect((state) => ({
  current: state.projects?.mspData?.current,
  projects: state.projects?.mspData?.projects,
  workflows: state.projects?.mspData?.workflows,
  steps: state.projects?.mspData?.steps
}), { createMspProject, loadStepsForMspProject, assignStep })
